import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { DELETE_PRICE_LISTS, FETCH_PRICE_LISTS } from "./graphql";

const DeletePriceListView = ({ priceListId, complete, cancel }) => {
  const [deletePriceList, deletePriceListRes] = useMutation(
    DELETE_PRICE_LISTS,
    {
      variables: { ids: [priceListId] },
      onCompleted() {
        Alert("success", "Price List Deleted.");
        complete();
      },
      onError(error) {
        Alert("error", error.message);
      },
      refetchQueries: [
        {
          query: FETCH_PRICE_LISTS,
        },
      ],
      awaitRefetchQueries: true,
    },
  );

  return (
    <div className="text-base">
      <div>Are you sure to delete this Price List?</div>

      <hr />

      <div className="flex space-x-8">
        <Button
          danger
          onClick={deletePriceList}
          loading={deletePriceListRes.loading}
        >
          Yes, Delete it.
        </Button>
        <Button onClick={cancel}>No, Keep it.</Button>
      </div>
    </div>
  );
};

export default DeletePriceListView;
